module.exports = __webpack_public_path__ + "img/47.829cbcff.jpg";